import { array, boolean, discriminatedUnion, literal, number, object, string } from "../../lazy-zod.js";
import { SPACE_FILE_MAX_SIZE_BYTES, spaceComposerUploadDescriptorSchema, spaceComposerUploadIdSchema, spaceFileClientMutationIdSchema, spaceFileDescriptorSchema, spaceFileEntryIdSchema, spaceFileMimeTypeSchema, spaceFileNameSchema, spaceFileOriginSchema } from "./space-files.js";
//#region src/schemas/http/space-file-upload.ts
const SPACE_FILE_UPLOAD_PART_BYTES = 8 * 1024 * 1024;
const SPACE_FILE_UPLOAD_TTL_MS = 1440 * 60 * 1e3;
const spaceFileUploadMetadataSchema = object({
	mimeType: spaceFileMimeTypeSchema,
	sizeBytes: number().int().min(1).max(SPACE_FILE_MAX_SIZE_BYTES),
	partDigests: array(string().regex(/^[a-f0-9]{64}$/u)).min(1).max(32),
	target: discriminatedUnion("kind", [
		object({
			kind: literal("composer"),
			name: spaceFileNameSchema
		}),
		object({
			kind: literal("file"),
			clientMutationId: spaceFileClientMutationIdSchema,
			name: spaceFileNameSchema,
			parentId: spaceFileEntryIdSchema.nullable(),
			origin: spaceFileOriginSchema.optional()
		}),
		object({
			kind: literal("revision"),
			clientMutationId: spaceFileClientMutationIdSchema,
			fileId: spaceFileEntryIdSchema,
			baseRevision: number().int().min(1)
		})
	])
});
const spaceFileUploadCommandSchema = discriminatedUnion("action", [
	object({
		action: literal("start"),
		metadata: spaceFileUploadMetadataSchema
	}),
	object({ action: literal("status") }),
	object({
		action: literal("part"),
		partNumber: number().int().min(1).max(32)
	}),
	object({ action: literal("complete") }),
	object({ action: literal("cancel") })
]);
const spaceFileUploadPartSchema = object({
	partNumber: number().int().min(1).max(32),
	etag: string().min(1),
	sizeBytes: number().int().min(1).max(SPACE_FILE_UPLOAD_PART_BYTES)
});
const spaceFileUploadResponseSchema = object({
	uploadId: spaceComposerUploadIdSchema,
	expiresAt: string().datetime(),
	partSizeBytes: literal(SPACE_FILE_UPLOAD_PART_BYTES),
	parts: array(spaceFileUploadPartSchema),
	file: spaceFileDescriptorSchema.optional(),
	upload: spaceComposerUploadDescriptorSchema.optional(),
	cancelled: boolean().optional()
});
//#endregion
export { SPACE_FILE_UPLOAD_PART_BYTES, SPACE_FILE_UPLOAD_TTL_MS, spaceFileUploadCommandSchema, spaceFileUploadMetadataSchema, spaceFileUploadPartSchema, spaceFileUploadResponseSchema };

//# sourceMappingURL=space-file-upload.js.map